export default {
  activateLandingPageTitle: 'Eventos',
  activateProductCardTitle: 'Eventos',
  activateProductPageTitle: 'Reservar eventos',
  allProductsLandingPageTitle: 'Reservar experiencias únicas',
  apply: 'Aplicar',
  buyTickets: 'Comprar entradas',
  cancel: 'Cancelar',
  clear: 'Limpiar',
  clearFilters: 'Limpiar filtros',
  discoverExperiences: 'Descubrir experiencias',
  exclusive: 'Exclusivo',
  experience: 'experiencia',
  experiencePhotoOfListing:
    'Foto de experiencia {{photoNumber}} del anuncio {{listingTitle}}',
  experiences: 'experiencias',
  filterExperiences: 'Filtrar experiencias',
  fromListingCard: 'De',
  hostedBy: 'Organizado por',
  hostLandingPageTitle: 'Experiencias locales',
  hostProductCardTitle: 'Experiencias locales',
  hostProductPageTitle: 'Reservar experiencias locales',
  landingPageTitle: 'Reservar experiencias únicas',
  mainLandingPageTitle: 'Todas las experiencias',
  more: 'Más',
  noExperiencesFound: 'No se encontraron experiencias',
  noExperiencesFoundFor: 'No se encontraron experiencias para',
  experiencesFoundCount: 'Se encontraron {{count}} experiencias',
  profileImageOfHost: 'Imagen de perfil de {{hostName}}',
  reserve: 'Reservar',
  reserveLandingPageTitle: 'Actividades y servicios',
  reserveProductCardTitle: 'Actividades',
  reserveProductPageTitle: 'Reservar actividades y servicios',
  resultsPageTitle: 'Reservar experiencias y actividades',
};
